export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 py-12 px-6 text-center" data-testid="empty-state">
      {Icon && (
        <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-blue-50 flex items-center justify-center">
          <Icon className="w-8 h-8 text-blue-600" />
        </div>
      )}
      <h3 className="text-xl font-bold text-slate-900 mb-1.5">{title}</h3>
      {description && <p className="text-slate-500 mb-6 max-w-md mx-auto">{description}</p>}
      {action}
    </div>
  );
}
